import { PropertyDetails } from './property-details.model';

export class OpportunitySelection {
    constructor(
        public opportunityId: number = 0,
        public oppSelectionModel: PropertyDetails = new PropertyDetails,
    ) { }
}